<template>
    <section>
        <header-components></header-components>
        <sidebar-components></sidebar-components>
        <content-components></content-components>
    </section>
</template>

<script>
  import Header from './Header.vue'
  import Sidebar from './Sidebar.vue'
  import Content from './Content.vue'

  export default {
    components: {
      "header-components":Header, 
      "sidebar-components":Sidebar, 
      "content-components":Content, 
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/admin/home/Index.vue